import React from 'react';

const Switch = ({label, id, name, onChange, className, inputClassName, labelClassName, checked = false}) => {
    return (
        <div className={"custom-control custom-switch " + (className ?? '')}>
            <input id={id} name={(name ?? '')} checked={checked ? 'checked' : ''} onChange={(e) => onChange(e.target.checked)} type="checkbox" className={"custom-control-input " + (inputClassName ?? '')}/>
            <label htmlFor={id} className={"custom-control-label cursor-pointer " + (labelClassName ?? '')}>{label}</label>
        </div>
    );
};

export default React.memo(Switch);
